import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonTextBadge } from './TextBadge.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTextBadge({ prefix }));
}
